/**
 * W-20 用户协议(公开,无守卫)。视觉真源 design/agreement.html。
 * 正文常量与 App 同源(`AGREEMENT_TEXT`);ICP/EDI 审核核查 Web 文本与申报材料一致(FR-13)。
 */
import { ProtocolView } from '@/components/shared/ProtocolView';
import { AGREEMENT_TEXT } from '@/common/copy/protocols';

export function AgreementPage() {
  return <ProtocolView title="用户协议" text={AGREEMENT_TEXT} testId="agreement-screen" />;
}
